import {
	Component,
	Input,
	OnInit,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "../common-imports"
import {
	Configcliniq,
	ConfigDefinitions,
	Holiday,
} from "@app/definitions/types"
import { dateDisplay } from "@app/helpers"
import { ApiService } from "@app/services/api.service"
import { LangService } from "@app/services/lang.service"
import { ModalService } from "@app/services/modal.service"
import { StoreService } from "@app/services/store.service"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { TimePickerComponent } from "@app/utils/time-picker/time-picker.component"
import { BtnExtComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-cc-params-holiday",
	imports: [COMMON_IMPORTS, LangValPipe, TimePickerComponent, BtnExtComponent],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./cc-params-holiday.component.html",
})
export class CcParamsHolidayComponent implements OnInit {
	configcliniq: Configcliniq //the config DB obj
	holidayGroupNames: string[] = [
		"national",
		"jewish",
		"muslim",
		"christian_catholic_protestant",
		"christian_orthodox",
		"druze",
		"cherkess",
	]
	holidayGroupsChecked: any = {}
	holidayGroups: any = {}
	// holidays: Holiday[] = [];
	isSaving: boolean = false

	constructor(
		protected apiService: ApiService,
		public lang: LangService,
		public modalService: ModalService,
		protected store: StoreService
	) {
		this.configcliniq = this.store.cc()
	}

	ngOnInit() {
		this.holidayGroups = {}
		this.holidayGroupsChecked = {}
		this.holidayGroupNames.forEach((holidayGroupName) => {
			this.holidayGroups[holidayGroupName] = []
			this.holidayGroupsChecked[holidayGroupName] = false
		})
		const holidays = this.store.getSiteDataTable("holidays")
		holidays.forEach((holiday) => {
			const holiday_group = holiday.holiday_group
			if (!this.holidayGroups[holiday_group]) {
				return
			}

			holiday.instancesFloat =
				this.lang.getVal("holiday_float_header") +
				"\n" +
				holiday.instances
					.map((instance) => {
						return `${dateDisplay(instance.date)} - ${dateDisplay(instance.date_to)}`
					})
					.join("\n")

			this.holidayGroups[holiday_group].push(holiday)
		})
	}
	async save() {
		if (this.isSaving) {
			return
		}
		this.isSaving = true
		const holidays: any[] = [] //will collect all holidays from all groups
		this.holidayGroupNames.forEach((holidayGroupName) => {
			//for each group name
			this.holidayGroups[holidayGroupName].forEach((holiday) => {
				//for each holiday in the array (of this group name)
				holidays.push(holiday) //add to holidays
			})
		})
		const res: any = await this.apiService.post("user_holiday_update", {
			holidays,
		})
		this.isSaving = false
		this.modalService.openToast("updated_successfully")
		this.store.getAllFus(true)
	}

	checkAll(holidayGroupName: string, checked: boolean) {
		this.holidayGroupsChecked[holidayGroupName] = checked
		this.holidayGroups[holidayGroupName].forEach((holiday) => {
			//for each holiday in the array (of this group name)
			holiday.active = checked ? "yes" : "no"
		})
	}
}
